import { useState } from 'react'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import { ActionConfigurationIdentifiers, MaterializedItem } from 'modules/processes/domain'
import questionGroups from 'modules/surveys/store/collections/questionGroups'

interface Props {
  items: MaterializedItem[]
  accessId: number
}

export interface ActionItem {
  action_id: number
  navigate: string
  completed: boolean
}

export const useActionItems = ({ items, accessId }: Props): ActionItem[] => {
  const [actions, setActions] = useState<ActionItem[]>([])
  const { navigation } = useNavigation()

  useEffect(() => {
    items
      .filter(
        (item) =>
          item.item?.action?.actionConfiguration?.id === ActionConfigurationIdentifiers.SendSurvey
      )
      .map((surveyItem) => {
        const surveyId = JSON.parse(surveyItem.item?.action?.configuration || '{}').survey_id

        questionGroups
          .fetch({
            data: {
              surveys_form_id: surveyId,
              respondent_id: accessId,
            },
          })
          .then((values) => {
            const newValues = values.map((value: Record<string, unknown>) => {
              return {
                action_id: surveyItem.id,
                navigate: navigation.engagement.surveys.id.responses.questionGroupId.fullPath({
                  id: surveyId,
                  question_group_id: String(value.id),
                }),
                completed: !!value.answered_at || false,
              }
            })

            setActions(newValues)
          })
      })
  }, [])

  return actions
}
